module.exports = __webpack_public_path__ + "static/media/chat-user-avatar.7769be69.svg";